import { getDocMenu } from './doc_menu';

const getMenuItems = () => {
  const menuItems = {
    items: [getDocMenu()],
    urlMap: {}
  };

  // Initialize urlMap
  menuItems.urlMap = menuItems.items.reduce((map, item) => {
    item.children.forEach((child) => {
      map[child.url] = child;
    });
    return map;
  }, {});
  return menuItems;
};

export { getMenuItems };
